export default (state = [], action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.parent_cities) {
        return payload.parent_cities;
      }
      return state;
    }
  }
};
